import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Container, Section } from '../ui/Section';
import { NewTabHint } from '../ui/NewTabHint';
import { Reveal, stagger } from '../motion/Reveal';
import { DoodleScatter } from '../brand/DoodleScatter';
import { officialChannels } from '../../data/site';

/**
 * Compact panel pointing students to the three official channels where the
 * current schedule actually lives. Reused on the homepage and Events page.
 */
export function ScheduleChannels({
  headingId = 'schedule-channels-heading'
}: {
  headingId?: string;
}) {
  return <Section className="relative overflow-hidden bg-brand-blue py-12 sm:py-16" labelledBy={headingId} data-id="element-295" data-mp="1t6lq455qugos">
      <DoodleScatter tone="blue" seed="schedule-channels" data-id="element-296" data-mp="1y4x32orc57b8" />
      <Container className="relative" data-id="element-297" data-mp="1y7ja8nabdksx">
        <Reveal data-id="element-298" data-mp="hr6wnbcqu6yf">
          <h2 id={headingId} className="font-display text-2xl font-extrabold leading-tight tracking-tight text-brand-navy sm:text-4xl" data-id="element-299" data-mp="hqndxsf9rejc">
            Get the latest BCM schedule
          </h2>
          <p className="mt-3 max-w-2xl font-sans text-[16px] leading-relaxed text-ink" data-id="element-300" data-mp="2qh9p5f29xymk">
            Special events, room changes, and weekly reminders are shared through BCM’s official
            student channels.
          </p>
        </Reveal>

        <ul className="mt-8 grid gap-4 sm:grid-cols-3" data-id="element-301" data-mp="2vfl0xvc4qj7f">
          {officialChannels.map((channel, index) => <Reveal key={channel.id} as="li" delay={stagger(index)} className="h-full" data-id="element-302" data-mp="39f40w0useo8n" data-mpi={index}>
              <a href={channel.href} target="_blank" rel="noopener noreferrer" className="flex h-full flex-col rounded-[20px] border-2 border-brand-navy bg-white p-5 transition-transform duration-200 hover:-translate-y-1" data-id="element-303" data-mp="34hc3wsfacbxl">
                <span className="flex items-center justify-between gap-2 font-display text-lg font-bold text-brand-navy" data-id="element-304" data-mp="3s5lojr0ritn5">
                  {channel.title}
                  <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 shrink-0" data-id="element-305" data-mp="3o2yqh8di0chi" />
                </span>
                <span className="mt-2 font-sans text-[14.5px] leading-relaxed text-ink" data-id="element-306" data-mp="41op95bpn1xv">
                  {channel.copy}
                </span>
                <NewTabHint data-id="element-307" data-mp="8zqhogv10dm0" />
              </a>
            </Reveal>)}
        </ul>
      </Container>
    </Section>;
}